var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaidBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9501 27.0667C47.2334 23.45 44.5501 21.8667 40.8168 21.8667H26.1834C21.7834 21.8667 18.8501 24.0667 18.8501 29.2V37.7834C18.8501 41.4834 20.3668 43.65 22.8668 44.5834C23.2334 44.7167 23.6334 44.8334 24.0501 44.9C24.7168 45.05 25.4334 45.1167 26.1834 45.1167H40.8334C45.2334 45.1167 48.1668 42.9167 48.1668 37.7834V29.2C48.1668 28.4167 48.1001 27.7167 47.9501 27.0667ZM25.2168 36C25.2168 36.6834 24.6501 37.25 23.9668 37.25C23.2834 37.25 22.7168 36.6834 22.7168 36V31C22.7168 30.3167 23.2834 29.75 23.9668 29.75C24.6501 29.75 25.2168 30.3167 25.2168 31V36ZM33.5001 37.9C31.0668 37.9 29.1001 35.9334 29.1001 33.5C29.1001 31.0667 31.0668 29.1 33.5001 29.1C35.9334 29.1 37.9001 31.0667 37.9001 33.5C37.9001 35.9334 35.9334 37.9 33.5001 37.9ZM44.2668 36C44.2668 36.6834 43.7001 37.25 43.0168 37.25C42.3334 37.25 41.7668 36.6834 41.7668 36V31C41.7668 30.3167 42.3334 29.75 43.0168 29.75C43.7001 29.75 44.2668 30.3167 44.2668 31V36Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1668 34.2V42.7833C53.1668 47.9167 50.2334 50.1334 45.8168 50.1334H31.1834C29.9334 50.1334 28.8168 49.95 27.8501 49.5833C27.0668 49.3 26.3834 48.8834 25.8334 48.35C25.5334 48.0667 25.7668 47.6167 26.1834 47.6167H40.8168C46.9834 47.6167 50.6501 43.95 50.6501 37.8V29.2C50.6501 28.8 51.1001 28.55 51.3834 28.85C52.5168 30.05 53.1668 31.8 53.1668 34.2Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidBw);
export default __webpack_public_path__ + "static/media/paid-bw.556e788f403c5c36f9b3be595eb78723.svg";
export { ForwardRef as ReactComponent };